import { SwitchableLocaleProvider, browserLocale } from '../../components/LanguageSwitch';

// Suppliers choose English or Spanish (most are in Spain). Their choice is
// remembered on the device; until they choose, it follows the browser.
export const SUPPLIER_LOCALE_KEY = 'mst_supplier_locale';

export function SupplierLocale({ children }) {
  return (
    <SwitchableLocaleProvider storageKey={SUPPLIER_LOCALE_KEY} defaultLocale={browserLocale()}>
      {children}
    </SwitchableLocaleProvider>
  );
}
